<div class="register-wrapper">
  <div class="left standard" *ngIf="registration.type === 0 || registration.type === 3">
    <img *ngIf="registration.logo" [src]="registration.logo | safe" />
    <span *ngIf="registration.text" class="text" [innerHtml]="registration.text | safeHTML"></span>
    <span *ngIf="registration.registerTitle" class="headline" [innerHtml]="registration.registerTitle | safeHTML"></span>
    <mat-spinner *ngIf="isLoading"></mat-spinner>
    <form class="marginTop" (submit)="onRegister()" [formGroup]="registerForm" *ngIf="!isLoading" data-private>
      <div *ngIf="errorEmailExists" class="invalid">
        Diese Email-Adresse ist bereits registriert. Bitte loggen Sie sich <a [routerLink]="['../login']">hier</a> ein.
      </div>
      <div class="form" *ngFor="let field of settings.fields; let i = index">
        <div class="checkbox" *ngIf="field.type === REGISTER_FIELDS_TYPES.CHECKBOX">
          <mat-checkbox [formControlName]="field.key">
            <span>{{ field.placeholder }}</span>
          </mat-checkbox>
          <mat-error *ngIf="(registerForm.controls[field.key].invalid && registerForm.controls[field.key].touched) || clickedRegister">
            {{ field.errorText }}
          </mat-error>
        </div>

        <div class="checkbox" *ngIf="field.type === REGISTER_FIELDS_TYPES.DATA_PRIVACY">
          <mat-checkbox [formControlName]="field.key">
            <div [innerHTML]="field.placeholder | safeHTML"></div>
          </mat-checkbox>

          <mat-error *ngIf="(registerForm.controls[field.key].invalid && registerForm.controls[field.key].touched) || clickedRegister">
            {{ field.errorText }}
          </mat-error>
        </div>

        <span class="label" *ngIf="field.type === REGISTER_FIELDS_TYPES.DROPDOWN" [innerHtml]="field.placeholder"></span>
        <mat-form-field *ngIf="field.type === REGISTER_FIELDS_TYPES.DROPDOWN" appearance="outline" color="accent">
          <mat-select name="dropdown" [formControlName]="field.key" [multiple]="field.multiselect">
            <mat-option *ngFor="let option of field.dropdownOptions" [value]="option">{{ option }}</mat-option>
          </mat-select>
          <mat-error *ngIf="registerForm.controls[field.key].invalid">{{ field.errorText }}</mat-error>
        </mat-form-field>

        <span
          class="label"
          *ngIf="field.type === REGISTER_FIELDS_TYPES.TEXT || field.type === REGISTER_FIELDS_TYPES.EMAIL"
          [innerHtml]="field.placeholder"
        ></span>
        <mat-form-field
          appearance="outline"
          color="accent"
          class="form-field"
          *ngIf="(field.type === REGISTER_FIELDS_TYPES.TEXT || field.type === REGISTER_FIELDS_TYPES.EMAIL) && field.key !== 'password'"
        >
          <input
            [id]="field.key"
            (change)="trimValue($event)"
            matInput
            [formControlName]="field.key"
            placeholder="{{ field.placeholder }}"
          />
          <mat-error *ngIf="registerForm.controls[field.key].invalid">{{ field.errorText }}</mat-error>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          color="accent"
          class="form-field"
          [class.form-field-error]="
            registerForm.controls[field.key].touched &&
            (registerForm.controls[field.key].hasError('pattern') ||
              registerForm.controls[field.key].hasError('minlength') ||
              registerForm.controls[field.key].invalid)
          "
          *ngIf="field.type === REGISTER_FIELDS_TYPES.TEXT && field.key === 'password'"
        >
          <input
            [id]="field.key"
            (change)="trimValue($event)"
            matInput
            [type]="hidePw ? 'password' : 'text'"
            [formControlName]="field.key"
            placeholder="{{ field.placeholder }}"
          />
          <span
            class="hidePwButton"
            mat-icon-button
            matSuffix
            (click)="hidePw = !hidePw"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hidePw"
          >
            <mat-icon>{{ hidePw ? 'visibility' : 'visibility_off' }}</mat-icon>
          </span>
          <mat-error *ngIf="registerForm.controls[field.key].invalid">{{ field.errorText }}</mat-error>
        </mat-form-field>
      </div>
      <button class="registerButton" mat-flat-button color="primary" type="submit">{{ settings.buttonText }}</button>
    </form>
    <div class="row marginTop" *ngIf="toLogin">
      <span class="loginText" [innerHtml]="registration.alreadyRegisteredText | safeHTML"></span>
      <a class="questionButton" [routerLink]="['../login']">{{ registration.toLoginButtonText }}</a>
    </div>
  </div>
  <div class="left iframe" *ngIf="registration.type === 1">
    <img *ngIf="registration.logo" [src]="registration.logo | safe" />
    <span *ngIf="registration.text" class="text" [innerHtml]="registration.text | safeHTML"></span>
    <span *ngIf="registration.registerTitle" class="headline" [innerHtml]="registration.registerTitle | safeHTML"></span>
    <mat-spinner *ngIf="isLoading"></mat-spinner>
    <iframe
      [src]="url | safe"
      frameborder="0"
      allow="accelerometer; encrypted-media; gyroscope; autoplay; allow-top-navigation; allow-scripts;
        allow-forms; allow-same-origin; allow-popups; picture-in-picture; camera; microphone; allow-downloads"
      allowfullscreen
    >
    </iframe>
    <div class="row marginTop" *ngIf="toLogin">
      <span class="loginText" [innerHtml]="registration.alreadyRegisteredText | safeHTML"></span>
      <a class="questionButton" [routerLink]="['../login']">{{ registration.toLoginButtonText }}</a>
    </div>
  </div>

  <div class="left eventbrite" *ngIf="registration.type === 2">
    <img *ngIf="registration.logo" [src]="registration.logo | safe" />
    <span *ngIf="login.text" class="text" [innerHtml]="login.text | safeHTML"></span>
    <span *ngIf="registration.registerTitle" class="headline" [innerHtml]="registration.registerTitle | safeHTML"></span>
    <mat-spinner *ngIf="isLoading"></mat-spinner>
    <div style="width: inherit;" id="eventbriteWidget"></div>
    <div class="row marginTop" *ngIf="toLogin">
      <span class="loginText" [innerHtml]="registration.alreadyRegisteredText | safeHTML"></span>
      <a class="questionButton" [routerLink]="['../login']">{{ registration.toLoginButtonText }}</a>
    </div>
  </div>

  <div class="image-div" *ngIf="registration.image">
    <img [src]="registration.image | safe" />
  </div>
  <div class="right" *ngIf="!registration.image"></div>
</div>

<!-- Haix Template keep for future use
 --><!-- <div *ngIf="customApp.eventId === '6027e086329caaf51d843842  '" class="haix">
  <div class="col-1-2 left">
    <div class="row-1-2">
      <img alt="Haix Main" src="https://philips.s3.eu-central-1.amazonaws.com/haix/haix-main.png" />
    </div>
    <div class="row-1-2 text">
      <h2>VIRTUAL LAUNCH-EVENT | CONNEXIS® GO<br />LIVE ERLEBEN - 19. März 2021 | 11 UHR</h2>
      <p>
        Brechen Sie mit uns auf in eine neue Ära. Am 19. März enthüllen wir CONNEXIS® GO, den ersten Lifestyle-Schuh, der mit aktiver
        Faszienstimulation die Leistung steigert. Für volle Energie und spürbar mehr Power.
      </p>
      <p>
        Als Moderatorin wird Sie die ehemalige Kickbox-Weltmeisterin und Medizinerin Dr. Christine Theiss durch das Event leiten. Gemeinsam
        mit weiteren Expert:innen aus Humanbiologie und Schuhtechnik führt Sie Frau Dr. Theiss durch die Entwicklung von CONNEXIS® GO und
        nimmt Sie mit auf eine Reise unter unsere Haut – in die faszinierende Welt der Faszien.
      </p>
      <p>
        Obwohl die Veranstaltung rein digital stattfinden wird, planen wir für Sie ein spannendes, einzigartiges Erlebnis. Damit Sie den
        Launch von CONNEXIS® GO hautnah miterleben können, erhalten Sie vorab eine Event-Box, die für die Veranstaltung benötigtes Material
        enthält, das extra auf Sie zugeschnitten ist.
      </p>
      <p>Bitte planen Sie für die Veranstaltung ca. eine Stunde Zeit ein.</p>
      <p>Ihre Log-In Daten erhalten Sie am Dienstag, 16. März 2021 per E-Mail.</p>
      <p class="links">
        <strong
          ><a href="mailto:event@haix.de" target="_blank">Kontakt</a> | <a href="https://www.haix.de/" target="_blank">Webshop</a></strong
        >
      </p>
    </div>
  </div>
  <div class="col-1-2 right">
    <div class="row-1-4">
      <img alt="lift your limits" class="liftyourlimits" src="https://philips.s3.eu-central-1.amazonaws.com/haix/lift-your-limits.png" />
    </div>
    <div class="row-1-2">
      <h2 class="anmeldung">Log-In - ab 16. März 2021 möglich</h2>
      <mat-card>
        <mat-spinner *ngIf="isLoading"></mat-spinner>
        <mat-card-title>{{ settings.registerHeadline }}</mat-card-title>
        {{ settings.registerText }}
        <form [formGroup]="registerForm" (submit)="onRegister()" *ngIf="!isLoading">
          <div *ngFor="let field of settings.fields; let i = index">
            <div *ngIf="field.type === REGISTER_FIELDS_TYPES.CHECKBOX">
              <mat-checkbox [formControlName]="field.key">
                {{ field.placeholder }}
              </mat-checkbox>
              <mat-error *ngIf="(registerForm.controls[field.key].invalid && registerForm.controls[field.key].touched) || clickedRegister">
                {{ field.errorText }}
              </mat-error>
            </div>

            <div *ngIf="field.type === REGISTER_FIELDS_TYPES.DATA_PRIVACY" class="dataprivacy">
              <p class="link">
                <a href="{{ field.link }}" target="_blank">{{ field.placeholder }}</a>
              </p>
              <mat-checkbox [formControlName]="field.key">
                {{ field.agreeText }}
              </mat-checkbox>

              <mat-error *ngIf="(registerForm.controls[field.key].invalid && registerForm.controls[field.key].touched) || clickedRegister">
                {{ field.errorText }}
              </mat-error>
            </div>

            <mat-form-field *ngIf="field.type === REGISTER_FIELDS_TYPES.DROPDOWN">
              <mat-label>{{ field.placeholder }}</mat-label>
              <mat-select name="dropdown" [formControlName]="field.key">
                <mat-option *ngFor="let option of field.dropdownOptions" [value]="option">{{ option }}</mat-option>
              </mat-select>
              <mat-error *ngIf="registerForm.controls[field.key].invalid">{{ field.errorText }}</mat-error>
            </mat-form-field>

            <mat-form-field
              class="form-field"
              *ngIf="field.type === REGISTER_FIELDS_TYPES.TEXT || field.type === REGISTER_FIELDS_TYPES.EMAIL"
            >
              <input matInput [formControlName]="field.key" placeholder="{{ field.placeholder }}" />
              <mat-error *ngIf="registerForm.controls[field.key].invalid">{{ field.errorText }}</mat-error>
            </mat-form-field>
          </div>
          <button mat-flat-button color="accent" type="submit">{{ settings.buttonText }}</button>
        </form>
      </mat-card>
    </div>
    <div class="row-1-4"></div>
  </div>
</div>
 -->
